import React, { useState } from 'react';
import PortableText from '@sanity/block-content-to-react';
import styles from '../styles/body-text.module.scss';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const serializers = {
  marks: {
    link: ({ mark, children }) => {
      let { blank, href } = mark

      const domains = [
        'woolwichworks.netlify.app',
        'woolwich-phase-2.netlify.app',
        'woolwich.works'
      ];      
      
      if (domains.some((domain) => href.includes(domain))) href = href.replace(/^.*\/\/[^\/]+/, '');

      return blank ?
        <a href={href} target="_blank" rel="noreferrer noopener">{children}</a>
        : <a href={href}>{children}</a>
    }
  }
}

const BodyText = ({ blocks, readMore=false }) => {
  const [showMore, setShowMore] = useState(false);

  return (
    <>
      {
        (readMore === true && showMore === false) &&
        <>
          <PortableText
            blocks={[blocks[0]]}
            serializers={serializers}
          />
          <div onClick={() => setShowMore(true)} className={styles.readMore}>
            Read more <div className={styles.chevron}><FaChevronDown/></div>
          </div>
        </>
      }      
      {
        (readMore === true && showMore === true) &&
        <>
          <PortableText
            blocks={blocks}
            serializers={serializers}
          />
          <div onClick={() => setShowMore(false)} className={styles.readMore}>
            Read less <div className={styles.chevron}><FaChevronUp/></div>
          </div>
        </>
      }      
      {
        readMore === false &&
        <>
          <PortableText
            blocks={blocks}
            serializers={serializers}
          />
        </>
      }
    </>
  )
}

export default BodyText;